var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 75,
    viewBox: "0 0 99 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.901 33.3911L43.9953 45.4881H56.7049L53.7874 33.3911H45.901Z",
    fill: "#CCD6DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9716 43.3634H41.0922V47.2527H58.9716V43.3634Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6393 0H20.4828V37.7372H78.6393V0Z",
    fill: "#CCD6DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2967 1.9589H22.5684V32.1805H76.2967V1.9589Z",
    fill: "#003353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2325 35.8828C50.841 35.8828 51.3344 35.3901 51.3344 34.7824C51.3344 34.1747 50.841 33.6821 50.2325 33.6821C49.6239 33.6821 49.1306 34.1747 49.1306 34.7824C49.1306 35.3901 49.6239 35.8828 50.2325 35.8828Z",
    fill: "#A5A5A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2414 48.4091H4.77931V75H10.2414V48.4091Z",
    fill: "#C9C9C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2207 48.4091H88.7586V75H94.2207V48.4091Z",
    fill: "#C9C9C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99 44.3182H0V48.4091H99V44.3182Z",
    fill: "#C9C9C9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktop);
export default __webpack_public_path__ + "static/media/IconDesktop.bc2a21f8.svg";
export { ForwardRef as ReactComponent };